import type { LucideIcon } from 'lucide-react';
import type { SpookyIconComponent } from '../icons/SpookyIcons';

type Props = {
  icon: SpookyIconComponent | LucideIcon;
  label: string;
  value: number;
  onClick: () => void;
};

export const SummaryCard = ({ icon: Icon, label, value, onClick }: Props) => (
  <button type="button" className="summary-card" onClick={onClick} aria-label={`${label}: ${value}. Open ${label.toLowerCase()}.`}>
    <span className="summary-icon" aria-hidden="true"><Icon size={19} /></span>
    <span>
      <strong>{value}</strong>
      <small>{label}</small>
    </span>
  </button>
);
